import { handleRequest } from "../utilities/requestHandler";

export const getCasesBySite = (selectedSite) =>
    handleRequest("post", "/services/cases", {
        selectedSite: selectedSite,
    });

export const getWorkordersBySite = (selectedSite) =>
    handleRequest("post", "/services/workorders", {
        selectedSite: selectedSite,
    });


export const getWorkorderReport = (woNumber, reportType, reportId) =>
    handleRequest("post", "/services/workorders/report", {
        wo_number: woNumber,
        ...(reportType ? { report_type: reportType } : {}),
        ...(reportId ? { report_id: reportId } : {}),
    });

export const downloadWorkorderReport = (reportId) =>
    handleRequest("get", `/services/workorders/report/${reportId}/download`, null, {
        responseType: "blob",
    });
